
import { useState } from "react";
import { Bookmark } from "lucide-react";
import Header from "@/components/Header";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import SavedIdeasSection from "@/components/SavedIdeasSection";
import HistoryList from "@/components/history/HistoryList";
import { useHistory } from "@/hooks/useHistory";

export default function HistoryPage() {
  const { loading, history, savedIdeas, setSavedIdeas, deleteHistory } = useHistory();
  const [activeTab, setActiveTab] = useState("history");
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-secondary/30">
      <Header />
      
      <main className="container max-w-2xl mx-auto pt-20 pb-16 px-4">
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold font-display mt-6">Your Creative Collection</h1>
          <p className="text-muted-foreground mt-2 max-w-md mx-auto">
            Review your past captures and creative ideas
          </p>
        </div>
        
        <Tabs defaultValue="history" className="w-full" onValueChange={setActiveTab}>
          <TabsList className="grid w-full grid-cols-2 mb-6">
            <TabsTrigger value="history">Capture History</TabsTrigger>
            <TabsTrigger value="saved" className="flex items-center gap-1">
              <Bookmark className="h-4 w-4" />
              Saved Ideas
              {savedIdeas.length > 0 && (
                <span className="ml-1 bg-primary/20 text-primary text-xs px-1.5 py-0.5 rounded-full">
                  {savedIdeas.length}
                </span>
              )}
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="history">
            <HistoryList loading={loading} history={history} onDeleteHistory={deleteHistory} />
          </TabsContent>
          
          <TabsContent value="saved">
            <SavedIdeasSection savedIdeas={savedIdeas} setSavedIdeas={setSavedIdeas} />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
